import type { ApiObjectWithReferences } from "@/models/api";

export function compareObjectOrder(
  left: ApiObjectWithReferences,
  right: ApiObjectWithReferences
): number {
  const leftOrder = left.object.sort_order ?? left.object.id;
  const rightOrder = right.object.sort_order ?? right.object.id;
  if (leftOrder !== rightOrder) {
    return leftOrder - rightOrder;
  }
  return left.object.id - right.object.id;
}

export function sortObjectsCanonical(
  items: ApiObjectWithReferences[]
): ApiObjectWithReferences[] {
  return [...items].sort(compareObjectOrder);
}

export function sortObjectsForDisplay(
  items: ApiObjectWithReferences[],
  reverse: boolean
): ApiObjectWithReferences[] {
  const sorted = sortObjectsCanonical(items);
  return reverse ? sorted.reverse() : sorted;
}

export function visibleOrderToCanonicalIds(
  visibleIds: number[],
  reverse: boolean
): number[] {
  return reverse ? [...visibleIds].reverse() : [...visibleIds];
}
